// extracted by mini-css-extract-plugin
var _1 = "UserInvitationFormSubjectField-modulesubject__f9mL2 FieldStackedLabel-moduleFieldStackedLabel__iylwV Field-moduleField__kZH_K";
export { _1 as "subject" }
